<template>
  <div class="wrapper-outer" :class="slideOut.opened ? 'slide-out-open' : ''" id="wrapperOuter">
    <div id="wrapper">

      <SlideOut :slideOut="slideOut.opened" :component="slideOut.component" :componentProperties="slideOut.componentProperties" />

      <div class="content-outer">
        <Header />
        <div id="content">
          <div v-if="showMenu" class="col-xl-3 col-lg-4 col-md-12 menu">
            <Menu />
          </div>
          <div>
            <transition name="fade" mode="out-in">
              <ErrorPage v-if="pageError" :data="pageData" />
              <!-- Outputs what the current route is pointing to -->
              <router-view v-else></router-view>
            </transition>
          </div>
        </div>
        <Footer />
      </div>

      <MobileBlockScreen />
    </div>
  </div>
</template>

<script>
import ErrorPage from './ErrorPage.vue'
import { mapState } from 'vuex'
import Banner from './common/Banner.vue'
import Header from './common/Header.vue'
import Footer from './common/Footer.vue'
import SlideOut from './common/SlideOut.vue'
import MobileBlockScreen from './common/MobileBlockScreen.vue'

export default {
  components: { ErrorPage, Banner, SlideOut, Header, Footer, MobileBlockScreen },
  created() {
    this.$store.dispatch('global/fetchChunks')
  },
  computed: {
    ...mapState({
      pageError: (state) => state.global.pageData && state.global.pageData.page == 'error',
      pageData: (state) => state.global.pageData,
      slideOut: (state) => state.global.slideOut
    }),
    showMenu: function () {
      return this.$route.meta.showMenu
    }
  }
}
</script>

<style lang="scss">
</style>
